import { BookingModuleStoreType } from "PFApp/booking/store/booking_module_store";

export const calendarRootSelector = (state: BookingModuleStoreType) =>
  state.calendarRootByMode[state.calendarMode];
